import React, {useRef} from 'react'
import {HStack as C2HStack, Button as C2Button, Text as C2Text} from '@chakra-ui/react'
import {Button} from '@chakra-ui/react3'
import {useIntl} from 'react-intl'
import {GiftBoxIcon} from '../icons'
import {useAddGiftToBabylist} from '../../babylist-api'
import PropTypes from 'prop-types'

const AddToBabylist = ({product, variant, ...props}) => {
    const {formatMessage} = useIntl()
    const babylistBtnRef = useRef(null)
    const {enabled, execute, loading} = useAddGiftToBabylist(product, babylistBtnRef)

    if (!enabled) {
        return null
    }

    if (variant !== 'leap') {
        // TODO: Remove the Chakra 2 part once all dependencies have been migrated
        return (
            <C2HStack w="100%" justify={'center'} pb={{base: 2, md: 0}}>
                <C2Button
                    variant="babyList"
                    onClick={execute}
                    ref={babylistBtnRef}
                    isDisabled={loading}
                >
                    <C2HStack spacing={2} align="center">
                        <C2Text>
                            {formatMessage({
                                id: 'product_detail.link.add_to_babylist',
                                defaultMessage: 'Add to Babylist'
                            })}
                        </C2Text>
                        <GiftBoxIcon boxSize={4} />
                    </C2HStack>
                </C2Button>
            </C2HStack>
        )
    }

    return (
        <Button
            variant="babylistFilled"
            {...props}
            onClick={execute}
            ref={babylistBtnRef}
            isDisabled={loading}
        >
            <span>
                {formatMessage({
                    id: 'product_detail.link.add_to_babylist',
                    defaultMessage: 'Add to Babylist'
                })}
            </span>
            <GiftBoxIcon />
        </Button>
    )
}

AddToBabylist.propTypes = {
    product: PropTypes.object,
    variant: PropTypes.string
}

export default AddToBabylist
